import { reactive } from 'vue';

export const searchWordStore = reactive({
  searchText: ''
});
